<template>
  <div class="firmwareNew">
    <div class="section">
      <div class="search">
        <!-- <div class="list-header">
          <div class="title">{{$t('firmware.Firmware_Lists')}}</div>
        </div> -->
        <!-- <div class="search"> -->
        <button type="button" class="button-upload" @click="addFirmware()">
          {{ $t('firmware.Upload_firmware') }}
          <i class="iconfont icon-biaogegongneng_shangchuan"></i>
        </button>
      </div>
      <el-table class="tablemain tableloding" v-loading="isLoading" element-loading-spinner="el-icon-loading"
        height="100%" stripe border :data="dataCode"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" :empty-text="$t('account.nodata')">
        <el-table-column width="130px" type="index" :label="$t('recharge.serial_number')" header-align="center"
          align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="firmware" :label="this.$t('firmware.Firmware_Name')" min-width="150px"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="this.$t('firmware.Firmware_desrc')" min-width="150px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :title="scope.row.desc || '--'">{{ scope.row.desc || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('browse.desc')" min-width="150px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :title="scope.row.remark || '--'">{{ scope.row.remark || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="size" :label="this.$t('firmware.Size')" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="gts" :label="this.$t('firmware.Upload_Time')" min-width="150px"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column :label="this.$t('firmware.Operation')" fixed="right" width="100px" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-button type="text" class="operation" :title="$t('firmware.deleteFirmware')"
              @click="deleteFirmware(scope.row)">
              <i class="iconfont icon-caozuo_shanchu"></i>
            </el-button>
          </template>
        </el-table-column>
        <!-- 无数据 -->
        <!-- <div v-show="emptyText" slot="empty"><img src="@/assets/img/empty_text.png"/>
                <div style="line-height: 32px">{{$t('account.nodata')}}</div></div> -->
      </el-table>
      <div class="tablebottom">
        <!-- 批量占位 -->
        <span class="" style="margin-left:16px;"></span>
        <!-- v-show="paginationControl" -->
        <el-pagination class="pagination" background @size-change="getData(true)" @current-change="() => getData()"
          :current-page.sync="pagination.currentPage" :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize" layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total" popper-class="select-page">
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>

    <!-- 删除固件对话框 -->
    <!-- v-if="dialogVisible" -->
    <firmware-dialog :title="$t('firmware.del_firmware')" :visible.sync="dialogVisible"
      :class="{ 'showDialog': dialogVisible, 'hideDialog': !dialogVisible }" width="30vw" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span class="contentdelete" style="width:100%;text-align:left;">{{ $t('firmware.delete_firmware') }}</span>
        </div>
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;">{{ $t('account.notRecovered') }}</span>
        </div>
        <!-- <span class="contentdelete">{{$t('firmware.delete_firmware')}}</span> -->
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button type="button" class="btn btn-dark" @click="configdelete()" style="margin-right:10px;">{{
            $t('firmware.confirm') }}</button>
          <button type="button" class="btn btn-light" @click="dialogVisible = false">{{ $t('firmware.cancel') }}</button>
        </div>
      </div>
    </firmware-dialog>
    <!-- 删除固件结果提示(成功) -->
    <!-- v-if="firmwareDelSucVisible" -->
    <firmware-dialog :title="$t('datalogger.delResults')" :visible.sync="firmwareDelSucVisible"
      :class="{ 'showDialog': firmwareDelSucVisible, 'hideDialog': !firmwareDelSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('datalogger.deleteSuc') }}</span>
          <!-- <span class="showresulttext">{{FirmwareTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="firmwareDelSucVisible = false;">{{ $t('datalogger.confirm')
            }}</button>
          </div>
        </div>
      </div>
    </firmware-dialog>
    <!-- 删除固件结果提示(失败) -->
    <!-- v-if="firmwareDelFailVisible" -->
    <firmware-dialog :title="$t('datalogger.delResults')" :visible.sync="firmwareDelFailVisible"
      :class="{ 'showDialog': firmwareDelFailVisible, 'hideDialog': !firmwareDelFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ FirmwareTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="firmwareDelFailVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </firmware-dialog>

    <!-- 增加固件对话框 -->
    <!-- v-if="dialogAdd" -->
    <firmware-dialog :title="$t('firmware.Upload_firmware')"
      :class="{ 'showDialog': dialogAdd, 'hideDialog': !dialogAdd }" :visible.sync="dialogAdd" width="40vw" noFooter>
      <div slot="content">
        <el-form class="grid upload-container">
          <!-- <p>{{$t('firmware.Firmware_description')}}</p> -->
          <el-form-item :label="$t('firmware.Firmware_description')" size="small">
            <el-input v-model="desc" :placeholder="$t('firmware.enter_content')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('browse.desc')" size="small">
            <el-input v-model="remark" :placeholder="$t('firmware.enter_content')"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <div class="upload-contents">
              <button type="button" class="upload-buttonEquipment" @click.prevent="$refs.fileUploader.click()">
                <i class="iconfont icon-shangchuan1"></i>
                <!-- {{$t('datalogger.Upload')}} -->
              </button>
              <div class="upload-tip">{{ `${$t('datalogger.Upload')} (${$t('firmware.limit0')})` }}</div>
              <input type="file" class="upload-input" ref="fileUploader" accept=".hex,.bin,.s19"
                @change="uploadfile($event)" />
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align:right;">
          <button type="button" class="btn btn-dark" @click="warningTipButton">{{ $t('datalogger.confirm') }}</button>
          <!-- <button class="btn btn-light" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
        </div>
      </div>
      <div slot="footer">
        <!-- <button class="button-solid" @click="dialogAdd = false">{{$t('datalogger.confirm')}}</button> -->
        <!-- <button class="button-hollow" @click="dialogAdd = false">{{$t('firmware.cancel')}}</button> -->
      </div>
    </firmware-dialog>
    <!-- 增加固件结果提示(成功) -->
    <!-- v-if="addFirmwareSucVisible" -->
    <firmware-dialog :title="$t('datalogger.editResults')" :visible.sync="addFirmwareSucVisible"
      :class="{ 'showDialog': addFirmwareSucVisible, 'hideDialog': !addFirmwareSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <!-- <span class="showresulttext">{{$t('datalogger.modifySuc')}}</span> -->
          <span class="showresulttext">{{ FirmwareTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="addFirmwareSucVisible = false;">{{ $t('datalogger.confirm')
            }}</button>
          </div>
        </div>
      </div>
    </firmware-dialog>
    <!-- 增加固件结果提示(失败) -->
    <!-- v-if="addFirmwareFailVisible" -->
    <firmware-dialog :title="$t('datalogger.editResults')" :visible.sync="addFirmwareFailVisible"
      :class="{ 'showDialog': addFirmwareFailVisible, 'hideDialog': !addFirmwareFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ FirmwareTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="addFirmwareFailVisible = false;">{{
              $t('datalogger.confirm') }}</button>
          </div>
        </div>
      </div>
    </firmware-dialog>
  </div>
</template>
<script>
import firmwareDialog from "@/components/dialognew";
export default {
  components: {
    firmwareDialog
  },
  data () {
    return {
      // 判断是否有权限，之前的经销商不存在权限
      disPermissionsLogo:sessionStorage.getItem("disPermissionsLogo")?JSON.parse(sessionStorage.getItem("disPermissionsLogo")):false,
      // 页面权限集合
      btnList: sessionStorage.getItem("buttonArr")?JSON.parse(sessionStorage.getItem("buttonArr")):[],
      emptyText: false,
      paginationControl: false,
      isLoading: false,
      file: null, //保存上传文件流的容器
      form: {
        name: ""
      },
      desc: "",
      remark: "",//备注
      pagination: {
        currentPage: 1,
        pagesize: 15,
        // 默认 0
        total: 100
      },
      alarmtype: [
        {
          label: "Warning",
          value: "warning"
        },
        {
          label: "Error",
          value: "error"
        },
        {
          label: "Fault",
          value: "fault"
        }
      ],
      // 固件列表
      dataCode: [
        // { "firmware": "mcu+4g_3_5_4_2.bin-ota.bin",}
      ],
      params: "",
      // 删除固件
      dialogVisible: false,
      // 增加固件
      dialogAdd: false,
      // 增加固件成功
      addFirmwareSucVisible: false,
      // 增加固件失败
      addFirmwareFailVisible: false,
      // 增加固件成功
      firmwareDelSucVisible: false,
      // 增加固件失败
      firmwareDelFailVisible: false,
      // 操作固件返回提示
      FirmwareTipMsg: "",
    };
  },
  methods: {
    getData (reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      this.isLoading = true;
      this.$request.getUPG("/upg/api/auth/web/shineDess/collector/upgrade/queryFiremware", {
          page: this.pagination.currentPage - 1,
          pagesize: this.pagination.pagesize
        })
        .then(res => {
          if (res.code == 0) {
            res.data.items.forEach(item => {
              item.size = (item.size / 1024).toFixed(2);
            });
            this.dataCode = res.data.items;
            this.pagination.total = res.data.total;
            if (this.pagination.total > this.pagination.pagesize) {
              this.paginationControl = true
            }
          } else {
            this.emptyText = true;
            this.dataCode = [];
            this.pagination.total = 0;
          }
          this.isLoading = false;
        });
    },
    //删除固件进入界面按钮
    deleteFirmware (info) {
      if(this.disPermissionsLogo&&!this.btnList.includes('delete_firmware')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.dialogVisible = true;
      this.params = info;
    },
    //删除固件
    configdelete () {
      this.$request.delete(`/upg/api/auth/web/shineDess/collector/upgrade/delFiremware/${this.params.id}`).then(res => {
        if (res.code == 0) {
          // this.$message.success(this.$t("firmware.deleteSuc"));
          this.firmwareDelSucVisible = true;
          setTimeout(() => {
            this.getData();
          }, 500);
          this.dialogVisible = false;
        } else {
          // this.$message.error(this.$t(`errCode.${res.code}`));
          // this.FirmwareTipMsg = this.$t(`errCode.${res.code}`);
          this.FirmwareTipMsg = res.message;
          this.firmwareDelFailVisible = true;
        }
      });
    },
    //增加固件进入界面按钮
    addFirmware () {
      if(this.disPermissionsLogo&&!this.btnList.includes('upload_firmware')){
        return this.$message.warning(this.$t('account.No_permission_prompt'));
      }
      this.dialogAdd = true;
      // 在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM。
      this.$nextTick(() => {
        this.$refs.fileUploader.value = null;
        this.desc = null;
        this.remark = null;
      });
    },
    //点击选择文件的按钮(选择成功后直接关闭弹窗)
    uploadfile (event) {
      // this.$refs.upload.clearFiles()
      let file = event.target.files[0];
      if (file.size > 8 * 1024 * 1024) {
        this.$message.error(this.$t("createPlant.fileExceed"));
        return;
      }
      let suffix = file.name.split(".").slice(-1)[0];
      // console.log(suffix !== "bin" && suffix !== "hex" && suffix !== "S19",'suffix');
      if (suffix !== "bin" && suffix !== "hex" && suffix !== "S19") {
        this.$message.error(this.$t("firmware.error1"));
        return;
      }
      this.$request.uploadfileAxios(file, this.desc, this.remark).then(res => {
        if (res.code === 0) {
          this.$message.success(this.$t("createPlant.uploadSuccess"));
          // this.getData();
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else if (res.code === 6) {
          this.$message.error(this.$t("firmware.error1"));
          // 关闭二次弹窗
          this.dialogAdd = false;
        } else {
          // this.$message.error(this.$t(`errCode.${res.code}`));
          this.$message.error(res.message);
          // 关闭二次弹窗
          this.dialogAdd = false;
        }
        setTimeout(() => {
          this.getData();
        }, 500);
      });
    },
    //点击确定时友情提示让其上传固件文件
    warningTipButton () {
      this.$message.warning(this.$t("firmware.uploadTips"));
    },
  },
  mounted () {
    this.getData();
  }
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");

.firmwareNew {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: auto;
  margin: 20px;

  // margin: 24px 24px 50px 24px;
  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  .search {
    margin: 0px;
    align-self: flex-end;

    // display: flex;
    // justify-content: space-between;
    .button-upload {
      display: flex;
      //多语言状态下文字间隔优化
      line-height: 16px;
      justify-content: space-between;
      align-items: center;
      width: 114px;
      height: 48px;
      background: @primaryTextColor;
      color: rgb(34, 45, 53);
      font-size: 14px;
      border-radius: 0px;
      border: none;
      cursor: pointer;

      .ico-download {
        width: 16px;
        height: 16px;
        background: url(../../assets/img/general/Icon_Download.png) no-repeat;
        background-size: 100%;
        background-position: center;
        margin-left: 10px;
      }
    }
  }

  .upload-button {
    margin-left: 80px;
    padding: 6px 16px;
  }

  .section {
    // padding-bottom: 10px;
    flex: 1;
    display: flex;
    border-radius: 0px;
    border: none;
    flex-direction: column;
    background: rgb(34, 45, 53);
    padding: 0px;
    overflow: hidden;

    // .list-header {
    //   .title {
    //    font-size:16px;
    //    font-weight: bold;
    //    color: #333;
    //    letter-spacing: 1.5px;
    //     // .sc(24px, #333);
    //   }
    // }
    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2B3842;
          color: #15C491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7B8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2B3842;
        color: #7B8395;
      }
    }
  }

  // .contentdelete {
  //   font-size: 18px;
  //   color: rgba(255, 62, 62, 1);
  //   font-weight: bold;
  // }
  // .disabledescr {
  //   color: rgba(255, 255, 255, 1);
  //   font-size: 14px;
  // }
  .deletfotter {
    margin-top: 50px;

    .button-hollow {
      width: 100px;
      height: 40px;
      margin-right: 40px;
    }

    .button-solid {
      width: 100px;
      height: 40px;
    }
  }

  .upload-input {
    display: none;
  }

  // 上传固件弹窗
  .upload-contents {
    border-radius: 6px;
    border: 1px dashed rgba(255, 255, 255, 0.5);
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .upload-buttonEquipment {
      background: transparent;
      border: none;
      cursor: pointer;
      padding: 6px 16px 6px 10px;
      color: rgba(255, 255, 255, 0.5);
      font-size: 14px;

      i {
        color: rgb(56, 165, 118);
        font-size: 32px;
      }
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
<style lang="less">
.firmware {
  .search {

    .el-select,
    .el-input {
      width: 165px;

      .el-input__inner {
        height: 36px;
        line-height: 36px;
        border-radius: 20px;
      }
    }
  }

  .upload-button {
    width: 100%;
  }
}
</style>